import { Action, createHook, createStore } from 'react-sweet-state';

type MergeChecksState = {
  isMergeChecksFetchRetrying: boolean;
};

const initialState: MergeChecksState = {
  isMergeChecksFetchRetrying: false,
};

export const setIsMergeChecksFetchRetrying =
  (isRetrying: boolean): Action<MergeChecksState> =>
  ({ setState }) => {
    setState({ isMergeChecksFetchRetrying: isRetrying });
  };

const MergeChecksStore = createStore({
  initialState,
  actions: { setIsMergeChecksFetchRetrying },
});

export const useMergeChecks = createHook(MergeChecksStore);
